import styled from 'styled-components';
import * as grid from 'view/styles/grid';
import * as mixins from 'view/styles/mixins';

export const ArticleDescription = styled.p`
    ${mixins.multiLineClamp(2, grid.multiple(2.5).unitless)};
    margin: 0;
`;

export const ListItem = styled.li`
    margin: 0;
    list-style: none;
`;
